import type { GlobalRoutes } from '@/utils/routes/types'
import routesData from '@/data/routes-data.json'

export const routesConfig: GlobalRoutes = routesData.globalRoutes as unknown as GlobalRoutes
